import React from "react";
import {
  Box,
  chakra,
  Button,
  useColorMode,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react";
import {  FaTwitter, FaYoutube } from "react-icons/fa";

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

function FooterMain() {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box
      bg="#141414"
      color="white"
      borderTop="1px solid dodgerblue"
    >
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Text textAlign="center" ml={0}>
          © 2025 Blindfold Capital. All rights reserved
        </Text>
        <Stack direction={"row"} spacing={6}>
          <SocialButton label="Twitter" href="https://x.com/BlindfoldCrypto">
            <FaTwitter />
          </SocialButton>
          <SocialButton label="YouTube" href="https://youtube.com/@blindfoldCapital">
            <FaYoutube />
          </SocialButton>
        </Stack>
      </Container>
    </Box>
  );
}

export default FooterMain;
